export default __webpack_public_path__ + "static/student 1-69e4e07482e3cb92d91d330a66dfb1f3.png";